import template from './history.html';
import controller from './history.controller';

const historyMessageComponent = {
  restrict: 'E',
  controller,
  template
};

export default historyMessageComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/history/history.component.js
 **/